import React, { useState, useEffect } from 'react'
import { inputdescribe_dom, partialtitle_dom } from '../../../Invitationmaker/components/Commonelements/Commonelements'
import { CROSS_ICON, TRASH_ICON } from '../../../../../../config/svgicons'
import { iconwrapper } from '../../../../../../config/commonfunctions'

const CROSSICON_CSS = { width: 20, height: 20, display: 'flex', placeContent: 'center' }

function Editsingleguestcontent(props) {
    const {
        guestcats = [],
        guestgrps = [],
        guestrelas = [],
        update,
        rmv
    } = props
    const [editsingleguestname, setEditsingleguestname] = useState('')
    const [editsingleguestrela, setEditsingleguestrela] = useState([])
    const [editsingleguestcat, setEditsingleguestcat] = useState([])
    const [editsingleguestgrp, setEditsingleguestgrp] = useState('')
    const [editsingleguestindex, setEditsingleguestindex] = useState(-1)
    const [editsingletableindex, setEditsingletableindex] = useState(-1)

    const [allguestcats, setAllguestcats] = useState([])
    const [allguestrelas, setAllguestrelas] = useState([])


    useEffect(() => {
        const { data } = props
        if (data) {
            const { guest, tableindex, guestindex } = data
            setEditsingleguestname(guest['name'])
            setEditsingleguestrela(guest['relas'])
            setEditsingleguestcat(guest['cats'])
            setEditsingleguestgrp(guest['grp'])
            setEditsingleguestindex(guestindex)
            setEditsingletableindex(tableindex) // exist if is calling from edit table modal
        }
    }, [props])

    useEffect(() => {
        const { data } = props
        if (data) {
            setAllguestcats(() => {
                let allguestcats = guestcats.slice()
                for (let j = 0; j < editsingleguestcat.length; j++) {
                    if (allguestcats.includes(editsingleguestcat[j])) {
                        const index = allguestcats.indexOf(editsingleguestcat[j])
                        allguestcats.splice(index, 1)
                    }
                }
                return allguestcats
            })

            setAllguestrelas(() => {
                let allguestrelas = guestrelas.slice()
                for (let j = 0; j < editsingleguestrela.length; j++) {
                    if (allguestrelas.includes(editsingleguestrela[j])) {
                        const index = allguestrelas.indexOf(editsingleguestrela[j])
                        allguestrelas.splice(index, 1)
                    }
                }
                return allguestrelas
            })
        }

    }, [editsingleguestrela, editsingleguestcat])

    const delcat = (index) => {
        setEditsingleguestcat((arr) => {
            let new_arr = arr.slice()
            new_arr.splice(index, 1)
            return new_arr
        })
    }

    const delrela = (index) => {
        setEditsingleguestrela((arr) => {
            let new_arr = arr.slice()
            new_arr.splice(index, 1)
            return new_arr
        })
    }

    const category_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Category', {})}
            <div style={{ width: '100%', minHeight: 52, height: 'auto', flexWrap: 'wrap', padding: 5, display: 'flex', flexDirection: 'row', position: 'relative', backgroundColor: 'rgb(244, 245, 246)', }}>
                {editsingleguestcat.length > 0
                    ? editsingleguestcat.map((item, index) => {
                        return (
                            <div key={item + index} className='Rsvpexplorer_portaltag' style={{ padding: '5px 0px 5px 14px' }} >
                                <div style={{ display: 'flex', alignContent: 'center', textAlign: 'center', paddingRight: 6 }}>{item}</div>
                                <button
                                    style={{ padding: '0px 5px', color: '#b21212', backgroundColor: 'transparent', margin: 0, outline: 'none', border: 'none', }}
                                    onClick={() => { delcat(index) }}
                                >
                                    {iconwrapper(CROSS_ICON, CROSSICON_CSS)}
                                </button>
                            </div>
                        )
                    })
                    : null}
            </div>
        </aside>
        {allguestcats.length > 0
            ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
                {inputdescribe_dom(
                    `${guestcats.length} different categories.`,
                    { padding: '5px 5px 0px 5px' })
                }
                <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
                    {allguestcats.map((item, y) => {
                        return <button
                            key={y + 'item'}
                            className="Rsvpexplorer_portaltag"
                            onClick={() => {
                                setEditsingleguestcat((arr) => {
                                    let new_arr = arr.slice()
                                    if (editsingleguestcat.includes(item)) {
                                        const index = new_arr.indexOf(item)
                                        new_arr.splice(index, 1)
                                    }
                                    else {
                                        new_arr.push(item)
                                    }
                                    return new_arr
                                })
                            }}>
                            {item}
                        </button>
                    })}

                </div>
            </div>
            : null}
        <div style={{ height: 15 }} />
    </>

    const relationship_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Relationship(s)', {})}
            <div style={{ width: '100%', minHeight: 52, height: 'auto', flexWrap: 'wrap', padding: 5, display: 'flex', flexDirection: 'row', position: 'relative', backgroundColor: 'rgb(244, 245, 246)', }}>
                {editsingleguestrela.length > 0
                    ? editsingleguestrela.map((item, index) => {
                        return (
                            <div key={item + index} className='Rsvpexplorer_portaltag' style={{ padding: '5px 0px 5px 14px' }} >
                                <div style={{ display: 'flex', alignContent: 'center', textAlign: 'center', paddingRight: 6 }}>{item}</div>
                                <button
                                    style={{ padding: '0px 5px', color: '#b21212', backgroundColor: 'transparent', margin: 0, outline: 'none', border: 'none', }}
                                    onClick={() => { delrela(index) }}
                                >
                                    {iconwrapper(CROSS_ICON, CROSSICON_CSS)}
                                </button>
                            </div>
                        )
                    })
                    : null}
            </div>
        </aside>
        {allguestrelas.length > 0
            ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
                {inputdescribe_dom(
                    `${guestrelas.length} different relationships.`,
                    { padding: '5px 5px 0px 5px' })
                }
                <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
                    {allguestrelas.map((item, y) => {
                        return <button
                            key={y + 'item'}
                            className="Rsvpexplorer_portaltag"
                            onClick={() => {
                                setEditsingleguestrela((arr) => {
                                    let new_arr = arr.slice()
                                    if (editsingleguestrela.includes(item)) {
                                        const index = new_arr.indexOf(item)
                                        new_arr.splice(index, 1)
                                    }
                                    else {
                                        new_arr.push(item)
                                    }
                                    return new_arr
                                })

                            }}>
                            {item}
                        </button>
                    })}
                </div>
            </div>
            : null}
        <div style={{ height: 15 }} />
    </>

    const group_dom = <>
        <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
            {partialtitle_dom('Group', {})}
            <div style={{ width: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
                <select
                    style={{ width: '100%', height: 40, border: '' }}
                    value={editsingleguestgrp}
                    onChange={(e) => {
                        setEditsingleguestgrp(e.target.value)
                    }}
                >
                    {['', ...guestgrps].map((item, y) => {
                        return <option
                            key={y + 'item'}
                            className="Rsvpexplorer_portaltag"
                        >
                            {item}
                        </option>
                    })}
                </select>
            </div>
        </aside>
        <div style={{ height: 15 }} />
    </>

    const name_dom = <>
        <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 55 }}>
            {partialtitle_dom('Guest Name', {})}
            <input
                style={{ height: 40, padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
                value={editsingleguestname || ''}
                onChange={(e) => setEditsingleguestname(e.target.value)} />
        </aside>
        <div style={{ height: 15 }} />
    </>

    return <div className='Rsvpexplorer_portal' >
        <div className='Rsvpexplorer_portaltitle'>Edit Guest</div>
        <div style={{ display: 'flex', flexDirection: 'column', height: 'calc( 100% - 170px)' }}>
            <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'auto', height: 'auto', width: '100%', overflowY: 'auto', padding: '0px 10px' }}>
                <div key={'edittable'} className="scedit_troot" style={{ padding: 0, border: 'none' }} >
                    <div style={{ display: 'flex', flexDirection: 'row', }}>
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {name_dom}
                            {group_dom}
                            {relationship_dom}
                            {category_dom}
                        </div>
                    </div>
                </div>
            </div>

            <div className='gl_portalbtnrow'>
                <button onClick={() => rmv(editsingleguestindex, editsingletableindex)} style={{ borderRadius: 10, backgroundColor: '#ffffff', border: '1px solid var(--maindark)' }}>{iconwrapper(TRASH_ICON, { width: 24, height: 24 })}</button>
                <button
                    className='gl_portalupdatebtn'
                    onClick={() => update(editsingleguestindex, editsingleguestname, editsingleguestrela, editsingleguestcat, editsingletableindex, editsingleguestgrp)}
                >
                    Update
                </button>
            </div>

        </div>

    </div>

}

export default Editsingleguestcontent

// import React, { useState, useEffect } from 'react'
// import { EMPTYSPACE, ARROWDOWN_SMALL } from '../../../../../../config/constants'
// import { partialtitle_dom } from '../../../Invitationmaker/components/Commonelements/Commonelements'
// import { TRASH_ICON } from '../../../../../../config/svgicons'
// import { iconwrapper } from '../../../../../../config/commonfunctions'

// function Editsingleguestcontent(props) {
//     const { DEVICE_MODALWT_MAP, allcats, device, update, rmv } = props
//     const [editsingleguestname, setEditsingleguestname] = useState('')
//     const [editsingleguestrela, setEditsingleguestrela] = useState('')
//     const [editsingleguestcat, setEditsingleguestcat] = useState('')
//     const [editsingleguestindex, setEditsingleguestindex] = useState(-1)
//     const [editsingletableindex, setEditsingletableindex] = useState(-1)
//     const [catdd, setCatdd] = useState(-1) // category dropdown

//     useEffect(() => {
//         const { data } = props
//         setEditsingleguestname(data[0])
//         setEditsingleguestrela(data[1])
//         setEditsingleguestcat(data[2])
//         setEditsingleguestindex(data[3])
//         setEditsingletableindex(data[4]) // exist if is calling from edit table modal
//     }, [props])


//     return <div className='Rsvpexplorer_portal' >
//         <div className='Rsvpexplorer_portaltitle'>Edit Guest</div>
//         <div style={{ display: 'flex', flexDirection: 'column', height: 'calc( 100% - 170px)' }}>
//             <div style={{ display: 'flex', flexDirection: 'column', maxHeight: 'auto', height: 'auto', width: '100%', overflowY: 'auto', padding: '0px 10px' }}>
//                 <div key={'edittable'} className="scedit_troot" style={{ padding: 0, border: 'none' }} >
//                     <div style={{ display: 'flex', flexDirection: 'row', }}>

//                         <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

//                             <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 55 }}>
//                                 {partialtitle_dom('Guest Name', {})}
//                                 <input
//                                     style={{ height: 40, padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                     value={editsingleguestname || ''}
//                                     onChange={(e) => setEditsingleguestname(e.target.value)} />
//                             </aside>

//                             <div style={{ height: 15 }} />

//                             <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
//                                 {partialtitle_dom('Relationship', {})}
//                                 <input
//                                     style={{ height: 40, padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                     value={editsingleguestrela || ''}
//                                     onChange={(e) => setEditsingleguestrela(e.target.value)}
//                                 />
//                             </aside>

//                             <div style={{ height: 15 }} />

//                             <aside style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 40 }}>
//                                 {partialtitle_dom('Category', {})}
//                                 <div style={{ width: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
//                                     <input
//                                         style={{ height: 40, padding: 5, borderRadius: 5, width: 'calc( 100% - 30px )', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//                                         value={editsingleguestcat || ''}
//                                         onChange={(e) => setEditsingleguestcat(e.target.value)}
//                                     />
//                                     <button className="scedit_ddbtn" style={{ height: 40, display: 'flex', placeItems: 'center' }} onClick={() => catdd === 0 ? setCatdd(-1) : setCatdd(0)}> {ARROWDOWN_SMALL}</button>
//                                 </div>
//                             </aside>

//                             {catdd === 0
//                                 ? <div id='catdd' style={{ display: 'flex', flexDirection: 'column', width: '100%', border: '1px solid #707070', marginTop: 5, borderRadius: 5 }}>
//                                     {/* <div style={{ backgroundColor: '#ff4e4e', color: 'white', width: '100%', textTransform: 'uppercase' }} onClick={() => setCatdd(-1)}>close</div> */}
//                                     <div style={{ display: 'flex', flexDirection: 'row', padding: 5, flexWrap: 'wrap', }}>
//                                         {allcats.map((item, y) => {
//                                             return <button
//                                                 key={y + 'item'}
//                                                 className="Rsvpexplorer_portaltag"
//                                                 onClick={() => {
//                                                     setEditsingleguestcat(item)
//                                                     setCatdd(-1)
//                                                 }}>
//                                                 {item}
//                                             </button>
//                                         })}

//                                     </div>
//                                 </div>
//                                 : null}

//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className='gl_portalbtnrow'>
//                 <button onClick={() => rmv(editsingleguestindex, editsingletableindex)} style={{ borderRadius: 10, backgroundColor: '#ffffff', border: '1px solid var(--maindark)' }}>{iconwrapper(TRASH_ICON, { width: 24, height: 24 })}</button>
//                 <button className='gl_portalupdatebtn' onClick={() => update(editsingleguestindex, editsingleguestname, editsingleguestrela, editsingleguestcat, editsingletableindex)}>Update</button>
//             </div>



//             {/* <button className='Rsvpexplorer_portalsave' onClick={() => update(editsingleguestindex, editsingleguestname, editsingleguestrela, editsingleguestcat, editsingletableindex)}>Update</button> */}
//         </div>

//     </div>



//     // return <div className="scedit_modalroot" style={{ minWidth: DEVICE_MODALWT_MAP[device] }}>
//     //     <div className="scedit_gmodal">
//     //         <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%', minHeight: 55 }}>
//     //             <div>Guest Name</div>
//     //             <input
//     //                 style={{ padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//     //                 value={editsingleguestname || ''}
//     //                 onChange={(e) => setEditsingleguestname(e.target.value)} />
//     //         </aside>
//     //         {EMPTYSPACE}
//     //         <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
//     //             <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '50%', minHeight: 55 }}>
//     //                 <div>Guest Relationship</div>
//     //                 <input
//     //                     style={{ padding: 5, borderRadius: 5, width: '100%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//     //                     value={editsingleguestrela || ''}
//     //                     onChange={(e) => setEditsingleguestrela(e.target.value)} />
//     //             </aside>
//     //             {EMPTYSPACE}
//     //             <aside style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '50%', minHeight: 55, overflow: 'visible' }}>
//     //                 <div>Guest Category</div>

//     //                 <div style={{ width: '100%', display: 'flex', flexDirection: 'row', position: 'relative' }}>
//     //                     <input
//     //                         style={{ padding: 5, borderRadius: 5, width: '90%', whiteSpace: 'nowrap', outline: 'none', fontSize: 14, border: 'thin solid #707070', alignSelf: 'flex-start', }}
//     //                         value={editsingleguestcat || ''}
//     //                         onChange={(e) => setEditsingleguestcat(e.target.value)} />

//     //                     <button className="scedit_ddbtn" onClick={() => catdd > -1 ? setCatdd(-1) : setCatdd(0)}>{ARROWDOWN_SMALL}</button>
//     //                     {catdd === 0
//     //                         ? <div style={{ position: 'absolute', display: 'flex', flexDirection: 'column', width: '87%', border: 'thin solid silver', top: '100%', zIndex: 2 }}>
//     //                             <div style={{ backgroundColor: '#ff4e4e', color: 'white', width: '100%', textTransform: 'uppercase' }} onClick={() => setCatdd(-1)}>close</div>
//     //                             {allcats.map((item, y) => {
//     //                                 return <div
//     //                                     key={y + 'item'}
//     //                                     style={{ backgroundColor: 'white', cursor: 'pointer', padding: 8, borderTop: y !== 0 ? 'thin solid #707070' : '', }}
//     //                                     onClick={() => {
//     //                                         setEditsingleguestcat(item)
//     //                                         setCatdd(-1)
//     //                                     }}>{item}</div>
//     //                             })}
//     //                         </div>
//     //                         : null}
//     //                 </div>

//     //             </aside>
//     //         </div>
//     //     </div>
//     //     {EMPTYSPACE}
//     //     <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
//     //         <button style={{ ...BUTTONSTYLE, color: 'white', backgroundColor: '#eb5d7b', border: 'thin solid white' }} onClick={() => rmv(editsingleguestindex, editsingletableindex)}>Remove</button>
//     //         {EMPTYSPACE}
//     //         <button style={{ ...BUTTONSTYLE, width: '100%' }} onClick={() => update(editsingleguestindex, editsingleguestname, editsingleguestrela, editsingleguestcat, editsingletableindex)}>Update</button>
//     //     </div>
//     // </div>

// }

// export default Editsingleguestcontent


